export const successfulEventsList = {
    regenronList: [
        {
            key: 'Email',
            definition: 'Open & Click'
        },
        {
            key: 'EHR',
            definition: 'Click'
        },
        {
            key: 'Programmatic',
            definition: 'Click'
        },
        {
            key: 'eNewsletters',
            definition: 'Open & Click'
        },
        {
            key: 'Custom Media',
            definition: 'View, Page view, Video view'
        },
        {
            key: 'Endemic Display',
            definition: 'Click'
        },
        {
            key: 'Endemic Social Media',
            definition: 'Click'
        },
        {
            key: 'Banner Ad',
            definition: 'Click'
        }
    ],
    default: [
        {
            key: 'Email',
            definition: 'Open & Click'
        },
        {
            key: 'EHR',
            definition: 'Click'
        },
        {
            key: 'Programmatic',
            definition: 'Click'
        },
        {
            key: 'eNewsletters',
            definition: 'Click'
        },
        {
            key: 'Custom Media',
            definition: 'View, Page view, Video view'
        },
        {
            key: 'Endemic Display',
            definition: 'Click'
        },
        {
            key: 'Endemic Social Media',
            definition: 'Click'
        },
        {
            key: 'Banner Ad',
            definition: 'Click'
        }
    ]
};